// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file location_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { ListDisposalSitesRequestSchema, LocationCreateSchema, LocationListRequestSchema, LocationListSchema, LocationRequestSchema, LocationSchema, LocationUpdateSchema } from "./location_pb";
import { file_location } from "./location_pb";

/**
 * Describes the file location_service.proto.
 */
export const file_location_service: GenFile = /*@__PURE__*/
  fileDesc("ChZsb2NhdGlvbl9zZXJ2aWNlLnByb3RvEglyYWNjb29uYWkyowQKD0xvY2F0aW9uU2VydmljZRJCCg5DcmVhdGVMb2NhdGlvbhIZLnJhY2Nvb25haS5Mb2NhdGlvbkNyZWF0ZRoTLnJhY2Nvb25haS5Mb2NhdGlvbiIAEkoKDUxpc3RMb2NhdGlvbnMSHi5yYWNjb29uYWkuTG9jYXRpb25MaXN0UmVxdWVzdBoXLnJhY2Nvb25haS5Mb2NhdGlvbkxpc3QiABJECg9HZXRMb2NhdGlvbkJ5SWQSGi5yYWNjb29uYWkuTG9jYXRpb25SZXF1ZXN0GhMucmFjY29vbmFpLkxvY2F0aW9uIgASQgoOVXBkYXRlTG9jYXRpb24SGS5yYWNjb29uYWkuTG9jYXRpb25VcGRhdGUaEy5yYWNjb29uYWkuTG9jYXRpb24iABJKCg5EZWxldGVMb2NhdGlvbhIaLnJhY2Nvb25haS5Mb2NhdGlvblJlcXVlc3QaGi5yYWNjb29uYWkuTWVzc2FnZVJlc3BvbnNlIgASUwoRTGlzdERpc3Bvc2FsU2l0ZXMSIy5yYWNjb29uYWkuTGlzdERpc3Bvc2FsU2l0ZXNSZXF1ZXN0GhcucmFjY29vbmFpLkxvY2F0aW9uTGlzdCIAElUKGExpc3REZXN0aW5hdGlvbkxvY2F0aW9ucxIeLnJhY2Nvb25haS5Mb2NhdGlvbkxpc3RSZXF1ZXN0GhcucmFjY29vbmFpLkxvY2F0aW9uTGlzdCIAQgZaBC4vcGI", [file_general, file_location]);

/**
 * @generated from service raccoonai.LocationService
 */
export const LocationService: GenService<{
  /**
   * @generated from rpc raccoonai.LocationService.CreateLocation
   */
  createLocation: {
    methodKind: "unary";
    input: typeof LocationCreateSchema;
    output: typeof LocationSchema;
  },
  /**
   * @generated from rpc raccoonai.LocationService.ListLocations
   */
  listLocations: {
    methodKind: "unary";
    input: typeof LocationListRequestSchema;
    output: typeof LocationListSchema;
  },
  /**
   * @generated from rpc raccoonai.LocationService.GetLocationById
   */
  getLocationById: {
    methodKind: "unary";
    input: typeof LocationRequestSchema;
    output: typeof LocationSchema;
  },
  /**
   * @generated from rpc raccoonai.LocationService.UpdateLocation
   */
  updateLocation: {
    methodKind: "unary";
    input: typeof LocationUpdateSchema;
    output: typeof LocationSchema;
  },
  /**
   * @generated from rpc raccoonai.LocationService.DeleteLocation
   */
  deleteLocation: {
    methodKind: "unary";
    input: typeof LocationRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Lists all disposal sites, filter by organization settings
   *
   * @generated from rpc raccoonai.LocationService.ListDisposalSites
   */
  listDisposalSites: {
    methodKind: "unary";
    input: typeof ListDisposalSitesRequestSchema;
    output: typeof LocationListSchema;
  },
  /**
   * Locations of the requested organizations and of the ones they selected in
   * their settings, which own the disposal sites they unload at.
   *
   * @generated from rpc raccoonai.LocationService.ListDestinationLocations
   */
  listDestinationLocations: {
    methodKind: "unary";
    input: typeof LocationListRequestSchema;
    output: typeof LocationListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_location_service, 0);

